import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import ReactPlayer from 'react-player';
import {Button, Icon, Item} from 'semantic-ui-react';

import {parseAbbr} from '.';

import TimeAgo from '../../../components/TimeAgo';
import CardEmbed from '../../../components/card/Embed';
import CardHTML from '../../../components/card/HTML';
import CardImage from '../../../components/card/Image';
import CardVideo from '../../../components/card/Video';

const WIDTH = 700,
    byWidth = (a, b) => Math.abs(a.width - WIDTH) - Math.abs(b.width - WIDTH);

class RedditItem extends Component {

    constructor(props) {
        super(props);
        const {data} = props, {media_embed, selftext_html} = data;
        this.state = {
            embed: media_embed && media_embed.content
                ? media_embed.content
                : null,
            gif: this.getGifSource(data),
            html: selftext_html || null,
            image: this.getImageSource(data),
            video: this.getVideoSource(data)
        };
    }

    getGifSource({preview}) {
        const sources = [];
        if (preview) {
            if (preview.images) {
                for (let {variants}
                of preview.images) {
                    if (variants && variants.gif) {
                        sources.push(variants.gif.source);
                    }
                }
            }
        }
        return sources.length
            ? sources
                .sort(byWidth)
                .shift()
            : null;
    }

    getImageSource({preview}) {
        const sources = [];
        if (preview) {
            if (preview.images) {
                for (let {resolutions, source}
                of preview.images) {
                    if (source) {
                        sources.push(source);
                    }
                    if (resolutions) {
                        for (let resolution of resolutions) {
                            sources.push(resolution);
                        }
                    }
                }
            }
        }
        return sources.length
            ? sources
                .sort(byWidth)
                .shift()
            : null;
    }

    getVideoSource({url, preview, media}) {
        if (ReactPlayer.canPlay(url)) {
            // YouTube, Facebook, Twitch, SoundCloud, Streamable, Vimeo, Wistia and DailyMotion
            return {url};
        }
        // MP4 and WebM
        const sources = [],
            pushSources = source => {
                const {width, height} = source,
                    pushSource = src => sources.push({url: src, width, height});
                source.scrubber_media_url && pushSource(source.scrubber_media_url);
                source.fallback_url && pushSource(source.fallback_url);
                source.dash_url && pushSource(source.dash_url);
                // source.hls_url && pushSource(source.hls_url);
            };
        if (preview) {
            if (preview.images) {
                for (let {variants}
                of preview.images) {
                    if (variants) {
                        variants.mp4 && sources.push(variants.mp4.source);
                        variants.webm && sources.push(variants.webm.source);
                    }
                }
            }
            preview.reddit_video_preview && pushSources(preview.reddit_video_preview);
        }
        if (media) {
            media.reddit_video && pushSources(media.reddit_video);
        }
        return sources.length
            ? {
                url: sources
                    .sort(byWidth)
                    .map(src => src.url)
            }
            : null;
    }

    getContent() {
        const {
                data: {
                    domain,
                    url
                }
            } = this.props, {embed, gif, html, image, video} = this.state;
        if (gif) {
            return <CardImage href={url} image={gif} ratio={4 / 3}/>;
        }
        if (video) {
            return <CardVideo video={video}/>;
        }
        if (embed) {
            return <CardEmbed embed={embed}/>;
        }
        if (html) {
            return <CardHTML html={html}/>;
        }
        if (image) {
            return <CardImage href={url} image={image}/>;
        }
        return <Button as="a" className="RedditItem-button" href={url} target="_blank" basic={true}>
            <Icon name='external'/>
            <span>{domain.replace(/^self\./, "")}</span>
        </Button>;
    }

    shouldComponentUpdate({data: {
            id
        }}) {
        return id !== this.props.data.id;
    }

    render() {
        const {
                data: {
                    author,
                    created_utc,
                    subreddit,
                    title,
                    url
                },
                context
            } = this.props,
            content = this.getContent();
        return <Item className="RedditItem">
            <Item.Content>
                <Item.Header
                    as='a'
                    href={url}
                    target="_blank"
                    dangerouslySetInnerHTML={{
                        __html: parseAbbr(title)
                    }}/>
                <Item.Meta>
                    <small>submited</small>
                    <strong><TimeAgo timestamp={created_utc * 1000}/></strong>
                    <small>by</small>
                    <span>{author}</span>
                    {/* <Link to={`/user/${author}`}>{author}</Link> */}
                    <small>to</small>
                    <Link to={`${context}/r/${subreddit}`}>r/{subreddit}</Link>
                </Item.Meta>
                <Item.Description className="RedditItem-content">{content}</Item.Description>
                {/* <Item.Extra><a href={url}>{url}</a></Item.Extra> */}
            </Item.Content>
        </Item>;
    }
}

const mapStateToProps = ({
    navigation: {
        context: {
            reddit
        }
    }
}) => ({
    context: reddit || ""
});
export default connect(mapStateToProps)(RedditItem);


// WEBPACK FOOTER //
// ./src/portfolio/api/reddit/Item.js